/**
 * 缓存法条目录和内容
 * 如果有更新清除所有内容
 */
import { del, get, set } from 'idb-keyval'
import { fetchLawVersion } from '@/components/LawBook/api'


//  缓存的版本
export const LAWS_LIST_VERSION = 'LAWS_LIST_VERSION'
// 法条目录
export const LAWS_LIST_V2 = 'LAWS_LIST_V2'
// 法条内容
export const LAWS_LIST_V2_CONTENT = 'LAWS_LIST_V2_CONTENT'

//
export async function set_LAWS_LIST_VERSION(version) {
  try {
    await set(LAWS_LIST_VERSION, version)
  } catch (e) {
    console.error('设置缓存版本失败', e)
    return false
  }
}

export async function isUseCache() {
  try {
    const version = await fetchLawVersion()
    const localVersion = await get(LAWS_LIST_VERSION)
    if (version == localVersion) {
      // 使用缓存
      return true
    } else {
      // 不相等不适用缓存
      await Promise.all([del(LAWS_LIST_V2), del(LAWS_LIST_V2_CONTENT)])
      await set_LAWS_LIST_VERSION(version)
      return false
    }
  } catch (e) {
    return false
  }
}


export async function set_provision(key, value) {
  try {
    const content = await get(key)
    // TODO:组装数据
    await set(key, content)
  } catch (e) {
    return false
  }
  return true
}

export async function get_LAWS_LIST_V2() {
  try {
    return await get(LAWS_LIST_V2)
  } catch (e) {
    console.error(e)
    return false
  }
}

export async function getLawsListFromCache() {
  let list = null
  try {
    list = await get_LAWS_LIST_V2()
  } catch (e) {
    console.warn('异常', e)
  }
  return list
}


export async function set_LAWS_LIST_V2(content) {
  try {
    await set(LAWS_LIST_V2, content)
  } catch (e) {
    console.error(e)
    return false
  }
  return true
}

export async function get_provision_by_id(key, id) {
  try {
    const list = await get(key)
    if (list) {
      return list[id]
    }
    return false
  } catch (e) {
    console.error(e)
    return false
  }
}

export async function getLawContentFromCache(id) {
  try {
    return await get_provision_by_id(LAWS_LIST_V2_CONTENT, id)
  } catch (e) {
    console.error(e)
    return false
  }

}

export async function set_LAWS_Content(id, content) {
  try {
    const obj = await get(LAWS_LIST_V2_CONTENT) || {}
    obj[id] = content
    await set(LAWS_LIST_V2_CONTENT, obj)
  } catch (e) {
    console.error(e)
    return false
  }
  return true
}

export async function del_provision(key) {
  try {
    await del(key)
  } catch (e) {
    return false
  }
  return true
}

export async function delLawsList() {
  return del_provision(LAWS_LIST_V2)
}


export async function delLawsContent() {
  return del_provision(LAWS_LIST_V2_CONTENT)
}


